<div class="grid gap-2">
  <div class="flex flex-col gap-2">
    <label class="is-required" for="firstname1">{{
      'shared.changePassword.new_password' | translate
    }}</label>
    <p-password [(ngModel)]="password" [toggleMask]="true" fluid></p-password>
  </div>
  <div class="flex flex-col gap-2">
    <label class="is-required" for="lastname1">{{
      'shared.changePassword.confirm_password' | translate
    }}</label>
    <p-password
      [(ngModel)]="passwordConfirmation"
      [toggleMask]="true"
      [feedback]="false"
      fluid
    ></p-password>
  </div>
</div>

<div class="flex items-center justify-end mt-4">
  <p-button
    label="{{ 'shared.changePassword.change_password' | translate }}"
    icon="pi pi-check"
    [loading]="loading$ | async"
    [disabled]="
      passwordConfirmation === '' ||
      passwordConfirmation === undefined ||
      password === '' ||
      password === undefined
    "
    (click)="changePwd()"
    [appEventTracker]="{ action: 'change_password' }"
    variant="text"
  ></p-button>
  <p-button
    label="{{ 'shared.changePassword.cancel' | translate }}"
    icon="pi pi-times"
    severity="secondary"
    [disabled]="loading$ | async"
    (click)="cancelBtn()"
    variant="text"
  ></p-button>
</div>
